import { sound } from '../lib/sound.js';
import { haptic } from '../lib/telegram.js';

export function Intro({ returning, busy, onEnter }: { returning: boolean; busy: boolean; onEnter(): Promise<void> }): React.JSX.Element {
  const enter = async () => {
    await sound.unlock();
    haptic('create');
    await onEnter();
  };
  return (
    <main className="intro" aria-labelledby="intro-title">
      <div className="intro__halo" />
      <p className="eyebrow">Психомагия · живой мир</p>
      <h1 id="intro-title">{returning ? 'Ваша карта жива' : 'Смыслы'}</h1>
      <p className="intro__lead">{returning ? 'Посмотрим, что изменилось?' : 'Создайте карту того, ради чего вам действительно хочется жить.'}</p>
      <button className="button button--primary intro__button" onClick={() => void enter()} disabled={busy}>
        <span>{busy ? 'Приближаемся…' : returning ? 'Вернуться в мир' : 'Войти в мир'}</span>
        <span aria-hidden="true">→</span>
      </button>
      <p className="intro__hint">Касание включит мягкий звук мира</p>
    </main>
  );
}
